import { render, staticRenderFns } from "./delivery-template-import.vue?vue&type=template&id=a2c928d8"
import script from "./delivery-template-import.vue?vue&type=script&lang=js"
export * from "./delivery-template-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports